import React from 'react';
import styled from 'styled-components';
import LoaderImage from './LoaderImage';
const PageContentLoader = ({ height = 75, width = 75, isVisible = true, ...props }) => {
    return React.createElement(ContentLoader, { height: height, width: width, isVisible: isVisible, ...props });
};
const ContentLoader = styled(({ height, width, isVisible, ...rest }) => React.createElement(LoaderImage, { ...rest })) `
  display: none;
  display: ${props => props.isVisible && 'block'};

  margin: 20% auto 75px auto;

  height: ${props => props.height};
  width: ${props => props.width};
`;
export default PageContentLoader;
//# sourceMappingURL=PageContentLoader.js.map